export function isDefined<T>(x: T | undefined | null): x is T {
  return x !== null && typeof x !== 'undefined';
}

export function isObject<T extends object>(x: T | undefined | null): x is T {
  return isDefined(x) && typeof x === 'object';
}

// eslint-disable-next-line @typescript-eslint/ban-types
export function isFunction(x: unknown): x is Function {
  return typeof x === 'function';
}

export function stringify<T>(x: T): string {
  return typeof x === 'string' ? x : '';
}
